// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#account {\n    border: 2px solid #adadad;\n    border-radius: 8px;\n    padding: 1em;\n}", "",{"version":3,"sources":["webpack://src/components/MemberRegistration/CreateAccount/index.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":["#account {\n    border: 2px solid #adadad;\n    border-radius: 8px;\n    padding: 1em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
